import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { MOT_VALUATION_ROUTE, TAX_VALUATION_ROUTE } from '../Pages/CheckerRouter.utils';

type CheckerRouteInfo = { checkerPage?: 'motCheck' | 'taxCheck'; isResultsPage?: boolean; route: string };

export const useGetRouteAndPageName = () => {
  const { pathname } = useLocation();
  const isResultsPage = /\/results/.test(pathname);
  const routeInfo = useMemo<CheckerRouteInfo | null>(() => {
    if (/mot/.test(pathname)) {
      return {
        checkerPage: 'motCheck',
        isResultsPage,
        route: MOT_VALUATION_ROUTE,
      };
    }
    if (/tax/.test(pathname)) {
      return {
        checkerPage: 'taxCheck',
        isResultsPage,
        route: TAX_VALUATION_ROUTE,
      };
    }
    return { route: '/' };
  }, [isResultsPage, pathname]);

  return {
    isMotCheckRoute: routeInfo?.checkerPage === 'motCheck',
    isTaxCheckRoute: routeInfo?.checkerPage === 'taxCheck',
    pathname,
    routeInfo,
  };
};
